import { CPD_LOCALSTORAGE_KEY } from './constants';

export function getCPDTimestamp() {
  if (window.localStorage) {
    const timestamp = window.localStorage.getItem(CPD_LOCALSTORAGE_KEY);

    return timestamp ? Number(timestamp) : null;
  }

  return null;
}
